/**
 * Created by weijianli on 16/11/2.
 */
function getAjaxSign(params, cb) {
  let keys = [], str = '';
  for (var k in params) {
    keys.push(k);
  }
  keys = keys.sort();

  keys.forEach(function(key) {
//引号加转意
    let value = (typeof params[key] === 'string') ? params[key].replace(/"/g, '\\"') : params[key];
    str += key + '=' + value + '&';
  });
  str = str.replace(/&$/, '');
  if (window.callBridge) {
    window.callBridge('getAjaxSign', JSON.stringify({params: str}), function(response) {
      if (typeof response === 'string') {
        response = JSON.parse(response);
      }
      cb(response.sign);
    });
  } else {
    cb();
  }

}

export default getAjaxSign;
